import { render } from "./TitleScreen.vue?vue&type=template&id=14615f08"
import script from "./TitleScreen.vue?vue&type=script&lang=js"
export * from "./TitleScreen.vue?vue&type=script&lang=js"

import "./TitleScreen.vue?vue&type=style&index=0&id=14615f08&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__